var map = {
	"./prism-atom-dark.css": 46,
	"./prism-base16-ateliersulphurpool.light.css": 47,
	"./prism-cb.css": 48,
	"./prism-duotone-dark.css": 49,
	"./prism-duotone-earth.css": 50,
	"./prism-duotone-forest.css": 51,
	"./prism-duotone-light.css": 52,
	"./prism-duotone-sea.css": 53,
	"./prism-duotone-space.css": 54,
	"./prism-ghcolors.css": 55,
	"./prism-hopscotch.css": 56,
	"./prism-pojoaque.css": 57,
	"./prism-vs.css": 58,
	"./prism-xonokai.css": 59
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45;